export default "__VITE_ASSET__DIH7$BH9__"